var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringToDate, TaskPriorities, } from "./task.type";
export const getPrototypeOrValueFromValue = (value) => ({ isPrototype: false, value });
export const getBlankTaskTemplate = () => ({
    title: "",
    associatedPeople: [],
    resources: [],
    enabled: true,
    isKeyEngagement: true,
    priority: TaskPriorities.medium,
});
export const getTaskTemplateFromDto = (templateDto) => {
    const { createdDate, modifiedDate } = templateDto, template = __rest(templateDto, ["createdDate", "modifiedDate"]);
    if (!template.associatedPeople) {
        template.associatedPeople = [];
    }
    if (!template.resources) {
        template.resources = [];
    }
    template.createdDate = stringToDate(createdDate);
    template.modifiedDate = stringToDate(modifiedDate);
    // Cast through any to get flow to trust this conversion.
    return template;
};
export const getRequestFromTaskTemplate = (template) => {
    // We need to get rid of quite a few attributes and convert the status and priority to ids.
    // Because requests are exact object types,
    // we can't use a spread operator to automatically include attributes.
    const request = {
        title: template.title,
        description: template.description,
        enabled: template.enabled,
        isKeyEngagement: template.isKeyEngagement,
        priorityId: template.priority.id,
    };
    if (template.id) {
        request.id = template.id;
    }
    if (template.associatedPeople) {
        // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
        request.associatedPeople = template.associatedPeople.map((person) => person.personId);
    }
    if (template.resources) {
        request.resources = template.resources.map((resource) => resource.id);
    }
    if (template.status) {
        request.statusId = template.status.id;
    }
    if (template.templateTitle) {
        request.templateTitle = template.templateTitle;
    }
    else {
        request.templateTitle = template.title;
    }
    if (template.templateDescription) {
        request.templateDescription = template.templateDescription;
    }
    if (template.assignedPerson) {
        if (template.assignedPerson.isPrototype) {
            request.assignedPerson = {
                isPrototype: true,
                attributeKey: template.assignedPerson.value.attributeKey,
                key: template.assignedPerson.value.key,
            };
        }
        else {
            request.assignedPerson = {
                isPrototype: false,
                personId: template.assignedPerson.value.personId,
            };
        }
    }
    return request;
};
export const getTaskTemplateLiteFromDto = (dto) => {
    // We just need to convert the dates
    const template = Object.assign(Object.assign({}, dto), { createdDate: stringToDate(dto.createdDate), modifiedDate: stringToDate(dto.modifiedDate) });
    return template;
};
